import { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getLots, addLot, editLot } from '../../actions/other/lotsActions'
import { getForSelect } from '../../actions/other/zonesActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import LotForm from '../../components/forms/LotForm'

export default function Lots() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {lot, lots, resultlot, loading, total} = useSelector(state=>state.lots)
    const {zonesForSelect} = useSelector(state=>state.zones)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getLots(page, limit, search))
            dispatch(getForSelect())
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getLots(page, limit, search))
        }
    }, [page, limit, search])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({})
        setModalShow(true)
    }

    const selectLot = (lot) => {
        setFormState({...lot})
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        if(target.name === 'type' || target.name === 'handling' || target.name === 'handlingPhase'){
            const fieldsToClean = {
                type: ['handling', 'handlingPhase', 'subhandling'],
                handling: ['handlingPhase', 'subhandling'],
                handlingPhase: ['subhandling']
            }
            const fieldsToCleanCurrent = fieldsToClean[target.name] || []
            const restFormState = {...formState}
            fieldsToCleanCurrent.forEach(field => delete restFormState[field])

            setFormState({
                ...restFormState,
                [target.name]: target.value
            })
            return
        }else{
            setFormState({
                ...formState,
                [target.name]: target.value
            })
        }
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editLot(formState, formState._id))
        }else{
            dispatch(addLot(formState))
        }
        setIsRegistering(false)
    }

    useEffect(() => {
        if(resultlot){
            let resultlotnow = resultlot
            dispatch({ type: 'LOT_RESET_RESULT' })
            switch (resultlotnow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.lot.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.lot.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.lot.editSuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultlot])

    const columnsLot = [
        {
            name: t('admin.lot.identifier'),
            cell: lot =>
                <div className='cursor' onClick={() => selectLot(lot)}>
                    {lot.identifier}
                </div>,
            selector: (lot) => lot.identifier,
            sortable: true,
        },{
            name: t('admin.lot.zone'),
            cell: lot =>
                <div className='cursor' onClick={() => selectLot(lot)}>
                    {lot.zone?.name}
                </div>,
            selector: (lot) => lot.zone?.name,
            sortable: true,
        },{
            name: t('admin.lot.type'),
            cell: lot =>
                <div className='cursor' onClick={() => selectLot(lot)}>
                    {t('admin.lot.type_'+lot.type)}
                </div>,
            selector: (lot) => t('admin.lot.type_'+lot.type),
            sortable: true,
        },{
            name: t('admin.lot.handling'),
            cell: lot =>
                <div className='cursor' onClick={() => selectLot(lot)}>
                    {lot.handling ? t('admin.lot.handling_'+lot.handling) : '-'}
                </div>,
            selector: (lot) => lot.handling,
            sortable: true,
        },{
            name: '',
            width: '100px',
            cell: lot =>
                <div className='cursor' onClick={() => selectLot(lot)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.lot.lots')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className="fas fa-plus me-2"></i>  {t('admin.lot.createlot')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {lots?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsLot}
                                                data={lots}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.lot.thereisnotlot')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.lot.lot')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <LotForm
                        state={formState}
                        lottype={'admin'}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                        zoneOptions={zonesForSelect}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}